module.exports = __webpack_public_path__ + "static/media/cbs-news.d1707f98.jpg";